import {InteractionEvent, Point} from 'pixi.js';
import {IPoint} from '../interfaces/primitives/IPoint';
import {PixiApplicationController} from '../controllers/PixiApplicationController';
import {HoverableObject} from './HoverableObject';
import {DynamicData} from '../data/DynamicData';

export class DraggableObject extends HoverableObject
{
    dragged: boolean = false;
    protected pointerStartOffset: IPoint = {x: 0, y: 0};
    protected movePosition: Point = new Point();
    protected startMoveCoors: IPoint = {x: 0, y: 0};

    constructor() {
        super();
   }

    /**
     * Уничтожаем объект
     */
    destroy(): void {
        this.disableStageListeningDrag(false);

        super.destroy();
    }

    copyDragParams(pointerStartOffset: IPoint, startMoveCoors: IPoint, dragged: boolean): void {
        this.pointerStartOffset.x = pointerStartOffset.x;
        this.pointerStartOffset.y = pointerStartOffset.y;
        this.movePosition.set(0, 0);
        this.startMoveCoors.x = startMoveCoors.x;
        this.startMoveCoors.y = startMoveCoors.y;
        this.dragged = dragged;
    }

    /**
     * Ограничение перемещения внутри области перетаскивания
     * @param x - желаемая координата по горизонтали
     * @param y - желаемая координата по вертикали
     * @returns объект содержащий возможные координаты, полученные из желаемых
     */
    clampPos(x: number, y: number): IPoint {
        throw new Error('Must override method clampPos() of DraggableObject!');
    }

    /**
     * Применяем новые координаты мыши
     */
    tryMove(): void {
        this.dragged = true;
        let x: number = this.movePosition.x - this.pointerStartOffset.x;
        let y: number = this.movePosition.y - this.pointerStartOffset.y;
        this.moveTo(this.clampPos(x, y));
    }

    /**
     * Применяем позиционирование
     * @param position - объект содержащий координаты применяемой позиции по осям
     */
    moveTo(position: IPoint): void {
        this.x = position.x;
        this.y = position.y;
    }

    /**
     * Обработчик события pointerdown
     * @param e Событие взаимодейтсвия пользователя
     */
    onPointerDown(e: InteractionEvent): void {
        DynamicData.dragSomething = true;
        let position: Point = this.parent.toLocal(e.data.global);
        this.pointerStartOffset = {x: position.x - this.x, y: position.y - this.y};
        this.startMoveCoors.x = 0;
        this.startMoveCoors.y = 0;
        PixiApplicationController.app.stage.on('pointermove', this.onDragMove, this);
        PixiApplicationController.app.stage.on('pointerup', this.onPointerUp, this);
        PixiApplicationController.app.stage.on('pointerupoutside', this.onPointerUp, this);
        PixiApplicationController.app.stage.on('rightup', this.onRightUp, this);
    }

    /**
     * Обработчик события pointerup
     * @param e Событие взаимодейтсвия пользователя
     */
    onPointerUp(e: InteractionEvent): void {
        this.disableStageListeningDrag();
    }

    /**
     * Обработчик события pointerupoutside
     * @param e Событие взаимодейтсвия пользователя
     */
    onPointerUpOutside(e: InteractionEvent): void {
        this.disableStageListeningDrag();
    }

    /**
     * Обработчик события onrightup
     * @param e Событие взаимодейтсвия пользователя
     */
    onRightUp(e: InteractionEvent): void {
        this.onPointerUp(e);
    }

    /**
     * Обработчик события pointermove сцены
     * @param e Событие взаимодейтсвия пользователя
     */
    onDragMove(e: InteractionEvent): void {
        this.movePosition = this.parent.toLocal(e.data.global, void 0);
        this.tryMove();
    }

    /**
     * Убираем все слушатели взаимодействия со сценой
     * и устанавливаем курсор в исходное состояние
     */
    private disableStageListeningDrag(finishDrag: boolean = true): void {
        this.dragged = false;
        if (finishDrag) {
            DynamicData.dragSomething = false;
        }
        //disable 'rightup' before 'pointerup' to call onRightUp listener only, and then to process to onPointerUp inside
        PixiApplicationController.app.stage.off('rightup', this.onRightUp, this);
        PixiApplicationController.app.stage.off('pointerup', this.onPointerUp, this);
        PixiApplicationController.app.stage.off('pointermove', this.onDragMove, this);
        PixiApplicationController.app.stage.off('pointerupoutside', this.onPointerUp, this);
    }
}
